module.exports = __webpack_public_path__ + "img/advertising_column.caa8f339.svg";